module.exports = __webpack_public_path__ + "img/pause.2aad270a.svg";